// extracted by mini-css-extract-plugin
export default {"addToCartControl":"E1-z","giftCard":"F1-z","btnContainer":"G1-z","cartButton":"H1-z","disabled":"I1-z"};